
import { makeStyles } from '@mui/styles';

import CommonImages from '../../commons/images';

const styles = (theme) => ({

    container: {
      display: 'flex',

      height: '100vh',
      width: '100%',
     
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
    },

    spacer: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      display: 'flex',
      alignItems: 'center',
    },

    brandCoverSpace: {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: '#010134',
      width: '60%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      [theme.breakpoints.down('md')]: {
        width: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    brandCoverImage: {
      width: '100%',
    },

    formContainer: {
      width: '40%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      alignItems: 'center',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('md')]: {
        width: '50%',
        overflow: 'visible',
      },
    },

    form: {
      width: 320,

   
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      marginTop: '100px',

    },

    brandTitle: {
      fontSize: '24px !important',
      fontWeight: 'bold !important',
      color: '#250036',
    },

    brandLogoContainer: () => {
      
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '40px',

        marginBottom: '20px !important',
      };
    },
 
    logo: () => {
      return {
        width: '38x',
        height: '38px',
         
      }
    },
  
    logoWord: () => {
      return {
        marginLeft: '8px',
        height: '20px',
         
      }
    },

    brandLogoImage: () => {
      function logo () {
        return CommonImages.MY_ECAL_LOGO;
      }

      return {
        backgroundSize: '150px',
        width: '150px',
        height: '40px',
        backgroundImage: `url(${logo()})`,
      };
    },

    progress: {
      marginLeft: theme.spacing(4),
    },

    googleLogo: () => {
      return {
        width: 30,
        marginRight: theme.spacing(2),
      };
    },

    oauthButton: {
      boxShadow: theme.customShadows.widget,
      backgroundColor: 'white',
      width: '100%',
      textTransform: 'none !important',

      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 16px)',
      },

      '&.MuiButtonBase-root': {

        marginTop: '16px',

        backgroundColor: '#FFFFFF',

        '&:hover': {
          backgroundColor:  '#F1F1F1'
          
        },
      },

      '& .MuiButton-label': {
        textTransform: 'none !important',
      },
    },

    loginFooter: {
      position: 'fixed',
      bottom: 0,
    }

});

export default styles;
export const useStyles = makeStyles(styles);
